export type StateNodeInstruction = {
  content?: any;
  target?: string;
  listIndex?: any;
  instruction?: string;
  listMoveToIndex?: number;
};
class StateNode {
  private next: null;
  private automatic: boolean;
  private instruction: StateNodeInstruction;
  public previous: null;
  private childrenStateMachines: any[];
  constructor(payload: StateNodeInstruction) {
    this.next = null;
    this.automatic = false;
    this.instruction = payload;
    this.previous = null;
    this.childrenStateMachines = [];
  }
}

export default StateNode;
